import { toObj } from '../../helpers/data';
import type { ID } from '../../models';
import type { Subscription } from '../../models/subscription';

export async function getSubscription(subscriptionId: ID) {
  const { getClientProvider } = await import('./index');
  const { SubscriptionDatabase } = await import('../../db/subscription-database');

  const subscriptionDb = new SubscriptionDatabase({
    provider: getClientProvider(),
  });

  return subscriptionDb.get(subscriptionId).then((doc) => toObj(doc) as Subscription);
}
